import { render, staticRenderFns } from "./FormItemPedido.vue?vue&type=template&id=69be8a7d"
import script from "./FormItemPedido.vue?vue&type=script&lang=js"
export * from "./FormItemPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports